// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".53f2cfa011e13f96ce978d1d6bd14df525eb3143.chunk.js";
};